import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { INote } from "../model/INote";

@Injectable({
  providedIn: "root"
})

export class NotesService {

  private baseUrl = "api/Notes/";

  constructor(private http: HttpClient) { }

  getNotesListByUser(): Observable<Array<INote>> {
    return (this.http.get<Array<INote>>(this.baseUrl + "GetNotesListByUser"));
  }

  getNotesById(id): Observable<INote> {
    return (this.http.get<INote>(this.baseUrl + "GetNotesById?id=" + id));
  }

  GetUserNoteByStep(step: string): Observable<INote> {
    return (this.http.get<INote>(this.baseUrl + "GetUserNoteByStep?step=" + step));
  }

  deleteNotesById(id: number): Observable<any> {
    return this.http.post<any>(this.baseUrl + "DeleteNotesById", id);
  }

  saveNotes(notes: INote): Observable<any> {
    return this.http.post<any>(this.baseUrl + "SaveNotes", notes);
  }
}
